import React, { FC } from 'react'

import { Features } from 'generated/featureDefinitions'

import {
  FeatureAvailabilityType,
  useFeatureAvailability,
} from 'modules/core/hooks/useFeatureAvailability'

interface FeaturesProviderContextProps {
  featureAvailabilities: Partial<Record<Features, FeatureAvailabilityType>>
  loading: boolean
}

const FeaturesProviderContext = React.createContext<FeaturesProviderContextProps | null>(null)

interface FeaturesProviderProps {
  children: React.ReactNode
}

export const FeaturesProvider: FC<FeaturesProviderProps> = ({ children }) => {
  const { featureAvailability, loading } = useFeatureAvailability(Features.documents_templates)

  return (
    <FeaturesProviderContext.Provider
      value={{
        featureAvailabilities: { [Features.documents_templates]: featureAvailability },
        loading,
      }}
    >
      {children}
    </FeaturesProviderContext.Provider>
  )
}

export const useFeaturesProvider = (): FeaturesProviderContextProps => {
  const FeaturesProviderModule = React.useContext(FeaturesProviderContext)

  if (!FeaturesProviderModule)
    throw new Error('useFeaturesProvider must be used within an FeaturesProviderModule')

  return FeaturesProviderModule
}
